export default __webpack_public_path__ + "static/media/gallery_10.03fbac7a.jpg";